export const appName = window?.appData?.env?.APP_NAME || 'Power Shop'
export const kebab = window?.appData?.env?.KEBAB
export const snake = window?.appData?.env?.SNAKE
export const baseUrl = window?.appData?.env?.BASE_URL || '/'
export const renderId1 = window?.appData?.env?.RENDER_ID_1 || 'my-app'
export const renderId2 = window?.appData?.env?.RENDER_ID_2 || 'my-app'
export const renderId3 = window?.appData?.env?.RENDER_ID_3 || 'my-app'
export const renderId4 = window?.appData?.env?.RENDER_ID_4 || 'my-app'

export const apiUrl = window?.wpApiSettings?.root || '/wp-json'
export const ajaxUrl =
	window?.appData?.env?.ajaxUrl || '/wp-admin/admin-ajax.php'
export const siteUrl = window?.appData?.env?.siteUrl || '/'
export const checkoutUrl = window?.appData?.env?.checkoutUrl || '/checkout'
export const currentUserId = window?.appData?.env?.userId || '0'
export const postId = window?.appData?.env?.postId || '0'
export const permalink = window?.appData?.env?.permalink || '/'

export const apiTimeout = window?.appData?.env?.API_TIMEOUT || '30000'

// export const defaultImage = `${siteUrl}/wp-content/power-shop-release/js/dist/defaultImage.jpg`

export const elApiKey = 'F9B52619-A5AC9B31-F7E931B1-526AD47D'

export const colorPrimary = window?.appData?.settings?.colorPrimary || '#1677ff'
export const showConfetti = window?.appData?.settings?.showConfetti ?? true
export const showStock = window?.appData?.settings?.showStock ?? true
export const showBuyerCount = window?.appData?.settings?.showBuyerCount ?? true
export const enableVirtualList =
	window?.appData?.settings?.enableVirtualList ?? false

export const power_shop_meta_meta_id =
	window?.appData?.settings?.power_shop_meta_meta_id
